if (!customElements.get('variant-details-empire')) {
  customElements.define(
    'variant-details-empire',
    class VariantDetailsEmpire extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-vd-panel]'));
        this.ids = this.panels.map((panel) => String(panel.dataset.variantId));
        this.pendingTimeout = parseInt(this.dataset.pendingTimeout, 10) || 3000;
        this.timer = null;

        this.onVariantChanged = (event) => {
          const id = event?.detail?.variant?.id;
          if (id === undefined || id === null) return;
          // Ignore events from another product (quick view, recommendations).
          if (!this.ids.includes(String(id))) return;
          this.clearPending();
          this.show(String(id));
        };

        // product-info.js dispatches this on document after every successful
        // variant update. It does NOT fire when the selected option combination
        // has no matching variant: setUnavailable() returns before publishing.
        document.addEventListener('variant:changed', this.onVariantChanged);

        // Fired before the fetch starts. The timeout it arms is the only signal
        // we get that an unavailable combination was selected.
        const events = window.FoxTheme?.pubsub?.PUB_SUB_EVENTS;
        if (events?.optionValueSelectionChange) {
          this.unsubscribe = window.FoxTheme.pubsub.subscribe(
            events.optionValueSelectionChange,
            () => this.setPending()
          );
        }

        this.syncVisibility();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:changed', this.onVariantChanged);
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        if (this.timer) clearTimeout(this.timer);
      }

      setPending() {
        this.setAttribute('aria-busy', 'true');
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.clearPending();
          this.show(null);
        }, this.pendingTimeout);
      }

      clearPending() {
        if (this.timer) clearTimeout(this.timer);
        this.timer = null;
        this.removeAttribute('aria-busy');
      }

      show(variantId) {
        this.panels.forEach((panel) => {
          panel.hidden = variantId === null || panel.dataset.variantId !== variantId;
        });
        this.syncVisibility();
      }

      // Hide the whole block (label or accordion header included) when the
      // active variant has no value for this field.
      syncVisibility() {
        const active = this.panels.find((panel) => !panel.hidden);
        this.hidden = !active || active.dataset.vdEmpty === 'true';
      }
    }
  );
}